export default "__VITE_ASSET__NM4cBo_h__"